// extracted by mini-css-extract-plugin
module.exports = {"topList":"aside_topList__2NQCW","rootAside":"aside_rootAside__2M6lG","topListRoot":"aside_topListRoot__21sxx"};